import OrderPhase from '../../models/order/orderPhase.model';

const ORDER_PHASE_INITIALIZER: OrderPhase = {
  cor: '',
  id: '',
  nome: '',
};

export default ORDER_PHASE_INITIALIZER;
